/*
Floating label
Label in placed inside the input (like a placeholder), but moves to the top of the input when value is added
based on https://codepen.io/steamforge/pen/NBqMYj
*/
class FloatingLabel {
  constructor(el) {

    this._bindEvents(el);
  }

  /**
 * Add active class to the element, causing label to move up
 *
 * @param {object} event - event
 */
  _handleFocus (event) {
    const target = event.target;
    target.parentNode.classList.add('active');
  }

  /**
 * Remove active class from the element, causing label to return to original position
 *
 * @param {object} event - event
 */
  _handleBlur(event) {
    const target = event.target;
    if(!target.value) {
      target.parentNode.classList.remove('active');
    }
  }

  /**
 * Add active class to the element, causing label to move up
 *
 * @param {HTMLElement} dropdownParent - floating label container element
 */
  _handleDropdownSelect(dropdownParent) {
    dropdownParent.classList.add('active');
  }

  /**
   * Add active class to the parent element, causing label to move up
   * @param {object} event - event
   */
  _handleSelectChange (event) {
    const target = event.target;
    target.parentNode.parentNode.classList.add('active');
  }

  /**
 * Bind eventhandlers to the element and check if it already has value
 *
 * @param {HTMLElement} element - floating label container element
 */
  _bindEvents(element) {
    const floatField = element.querySelector('input');
    const dropDown = element.querySelector('.dropdown--container');
    const floatSelect = element.querySelector('select');

    let hasValue = false;

    if(floatField && (floatField.type !== 'radio' && floatField.type !== 'checkbox')) {
      hasValue = !!floatField.value; // check if has value
      floatField.addEventListener('focus', this._handleFocus);
      floatField.addEventListener('blur', this._handleBlur);

    } else if(dropDown) {
      const options = element.querySelector('.dropdown__options');
      hasValue = options.querySelectorAll('input[type="radio"]:checked').length; // check if has value

      options.addEventListener('click', () => {
        this._handleDropdownSelect(element);
      });

    } else if(floatSelect) {
      //is has selection, add class active
      if(floatSelect.selectedIndex > 0) {
        element.classList.add('active');
      }
      floatSelect.addEventListener("change", this._handleSelectChange);

    }

    //if the input has value, activate it
    if (hasValue) {
      element.classList.add('active');
    }

  }

}

/**
 * Create floating labels of elements that match the selector
 **/
function init () {
  const floatContainers = Array.from(document.querySelectorAll('.floating-label__container'));

  floatContainers.forEach((element) => {
    new FloatingLabel(element);
  });
}

export default { init };
export { init };
